import type { Theme } from "@mui/material/styles";

// Keep desktop styles owned by each dashboard; override only the PDA layout.
export const mobileDashboardHeaderSx = (theme: Theme) => ({
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "stretch",
    gap: 0,
    padding: 1.25,
    backgroundColor: "background.paper",
    border: "1px solid",
    borderColor: "divider",
    borderTop: "3px solid",
    borderTopColor: "secondary.main",
    borderRadius: 1,
    "& > div:first-of-type": { display: "none" },
    "& > .MuiStack-root": { margin: 0 }
  }
});

export const mobileDashboardActionsSx = (theme: Theme) => ({
  [theme.breakpoints.down("sm")]: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) auto",
    "& > button:first-of-type": {
      gridColumn: "1 / -1", width: "100%", justifyContent: "space-between",
      border: "1px solid", borderColor: "divider", margin: 0
    },
    "& > .MuiIconButton-root": {
      gridColumn: 2, gridRow: 2, width: 44, height: 44, margin: 0
    },
    "& > .MuiTypography-root": {
      gridColumn: 1, gridRow: 2, margin: 0, minWidth: 0, whiteSpace: "normal"
    }
  }
});
